import { getLocale } from "../runtime";

const sv_productssample = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Produkter`
};

const productssample = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_productssample(inputs)
	return "productsSample";
};

export { productssample as "productsSample" };